import React from 'react';

export default class Home extends React.Component {
  componentDidMount() {
    this.props.history.push('/sandbox/');
  }
  render() {
    return null;
  }
};